import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 1rem;
`;

export const Icon = styled.img`
  width: 6rem;
  height: 6rem;
  margin-bottom: 1rem;
`;

export const Title = styled(Typography)`
  font-size: 2.2rem;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spaces.xs}rem;
`;

export const Text = styled(Typography)`
  text-align: center;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.greyDark};
`;

/**
 * Línea de progreso de la descarga del APK. `tabular-nums` para que el número
 * no baile mientras sube: leerlo temblando da sensación de que algo falla.
 */
/**
 * Barra de la descarga del APK. Antes esto era una línea de texto suelta y un
 * operario en la tablet no sabía si la app estaba trabajando o colgada: en la
 * primera prueba de campo se dio por muerta una descarga que iba por el 40%.
 */
export const ProgressTrack = styled.div`
  width: 100%;
  max-width: 32rem;
  height: 0.8rem;
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.colors.greyLight};
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $percent: number }>`
  width: ${({ $percent }) => $percent}%;
  height: 100%;
  background: ${({ theme }) => theme.colors.primary};
  transition: width 0.2s ease;
`;

export const Version = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  /* Sin esto heredaba lo que cayera y se veía más pequeño que todo lo demás,
     mientras su hermano ErrorText sí declaraba el suyo. */
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.greyDark};
  font-variant-numeric: tabular-nums;
`;

export const ErrorText = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  /* Mismo tamaño que el texto del cuerpo: a 1.4rem un aviso de error se leía
     como una nota al pie, más pequeño que lo que acompaña. */
  font-size: ${({ theme }) => theme.fontSize.M};
  color: ${({ theme }) => theme.colors.red};
  max-width: 32rem;
  text-align: center;
`;
